import React from 'react'
import Icon from '@mui/icons-material/RuleFolderOutlined'
import { SvgIconProps } from '@mui/material/SvgIcon'

const RuleIcon = (props: SvgIconProps) => <Icon fontSize="small" {...props} />

export default RuleIcon
export {}
